var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { RenderBlock } from '../../render-layout.models';
/**
 * Banners hero - template-1 variant: the 3-banner grid (banner-1 large + 2 small), same structure
 * as the template-3 variant but with template-1's own sizing tokens and the `banner-next-draw`
 * label key. Lottery + asset helpers live on the shell (host).
 */
var BannersT1 = /** @class */ (function (_super) {
    __extends(BannersT1, _super);
    function BannersT1() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return BannersT1;
}(RenderBlock));
export { BannersT1 };
